import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.status = {
    key: 'status',
    label: translate('career.dashboard.JobListings.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('career.Status'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
